var _path, _path2, _path3;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgShare = function SvgShare(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5681 9.17969H18.3063C18.8118 9.17969 19.2966 9.38051 19.654 9.73796C20.0114 10.0954 20.2122 10.5802 20.2122 11.0858V21.2515C20.2122 21.757 20.0114 22.2418 19.654 22.5993C19.2966 22.9567 18.8118 23.1576 18.3063 23.1576H8.11099C7.60551 23.1576 7.12073 22.9567 6.76331 22.5993C6.40588 22.2418 6.20508 21.757 6.20508 21.2515V11.0858C6.20508 10.5802 6.40588 10.0954 6.76331 9.73796C7.12073 9.38051 7.60551 9.17969 8.11099 9.17969H9.87967",
    stroke: "#2555EF",
    strokeWidth: 0.948522,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2238 15.6313V2.54297L9.51367 6.25346",
    stroke: "#2555EF",
    strokeWidth: 0.948522,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9287 6.30429L13.2236 2.54297",
    stroke: "#2555EF",
    strokeWidth: 0.948522,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Share.4dd63edc.svg";
export { ForwardRef as ReactComponent };